import { render, staticRenderFns } from "./retreatMark.vue?vue&type=template&id=29ccd485&scoped=true&"
import script from "./retreatMark.vue?vue&type=script&lang=js&"
export * from "./retreatMark.vue?vue&type=script&lang=js&"
import style0 from "./retreatMark.vue?vue&type=style&index=0&id=29ccd485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ccd485",
  null
  
)

export default component.exports